/*
 * SashiDo
 * All rights reserved.
 */
import React from'react';

export default function Table(props) {
  let className = ['table', props.className]

  return <table {...props} className={className.join(' ')} />;
}
